export default __webpack_public_path__ + "static/SR USA - Organic Caramel Colors - Certificate-dd90461c4a3e758647f630f4f16278d2.pdf";